import { lazy } from "react";
import RouteGuard from "../routerPermission";

const Categories = lazy(() => import("@/widgets/catalog/categories/Categories"));
const CategoryWizardPage = lazy(() => import("@/widgets/catalog/categories/wizard/CategoryWizardPage"));
const CategoryDetailPage = lazy(() => import("@/widgets/catalog/categories/CategoryDetailPage"));
const CategoryEditPage = lazy(() => import("@/widgets/catalog/categories/CategoryEditPage"));
const Variant = lazy(() => import("@/widgets/catalog/categories/variant/VarientDetail"));
const VariantGroup = lazy(() => import("@/widgets/catalog/categories/variant/VarientGroup"));

const CategoriesRoutes = {
  path: "categories",
  children: [
    {
      path: "",
      element: (
        <RouteGuard resource="product" action="read">
          <Categories />
        </RouteGuard>
      ),
    },
    {
      path: "add-new-category",
      element: (
        <RouteGuard resource="product" action="create">
          <CategoryWizardPage />
        </RouteGuard>
      ),
    },
    {
      path: ":categoryId",
      children: [
        {
          path: "",
          element: (
            <RouteGuard resource="product" action="read">
              <CategoryDetailPage />
            </RouteGuard>
          ),
        },
        {
          path: "edit",
          element: (
            <RouteGuard resource="product" action="update">
              <CategoryEditPage />
            </RouteGuard>
          ),
        },
        {
          path: ":varientType",
          children: [
            {
              path: "",
              element: (
                <RouteGuard resource="product" action="read">
                  <Variant />
                </RouteGuard>
              ),
            },
            {
              path: ":groupId",
              element: (
                <RouteGuard resource="product" action="read">
                  <VariantGroup />
                </RouteGuard>
              ),
            },
          ],
        },
      ],
    },
  ],
};

export default CategoriesRoutes;
